import React, { useRef, useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import HeaderInner from "../../Components/HeaderInner";
import { useLocation, useNavigate } from "react-router-dom";
import { ShowWheelchair } from "../../API/Concierge";
import { useTranslation } from "react-i18next";
import axios from "../../axios";
import { Toast } from "primereact/toast";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import "../../new-pages/hotel-services/HotelServices.scss";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import BannerServices from "../../new-components/banner-home/BannerServices";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import useMixpanel from "../../hooks/useMixpanel";
import { trackMenuItemViewed } from "../../utils/mixpanel";

function Wheelchair() {
  const { track } = useMixpanel();
  const toast = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const room_uuid = location.pathname.split("/")[1];
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";
  const lang = localStorage.getItem("lang");

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [timeInput, setTimeInput] = useState("");
  const [dateInput, setDateInput] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errorEmail, setErrorEmail] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 1);
    const hh = now.getHours().toString().padStart(2, "0");
    const mm = now.getMinutes().toString().padStart(2, "0");
    setTimeInput(`${hh}:${mm}`);
    setDateInput(new Date().toISOString().slice(0, 10));
  }, []);

  const { data, isLoading } = ShowWheelchair(room_uuid, lang);
  let serviceData;
  let text;
  if (!isLoading) {
    serviceData = data.data.data;
    text = serviceData?.center_header;
  }

  useEffect(() => {
    if (!isLoading && serviceData) {
      trackMenuItemViewed({
        item_id: serviceData?.id || "",
        item_name: serviceData?.title || "Wheelchair",
        category_name: "Concierge",
        price: 0,
      });
    }
  }, [isLoading]);

  const handelBook = () => {
    if (email.length > 0 && !/\S+@\S+\.\S+/.test(email)) {
      setErrorEmail("The email must be a valid email address.");
      return;
    }
    setErrorEmail("");
    setIsDisabled(true);

    const sendData = {
      type_id: "wheelchair",
      date: dateInput,
      time: timeInput,
      email,
      phone,
      note,
    };

    axios
      .post(`/${room_uuid}/concierge/book-service`, sendData, {
        headers: { lang },
      })
      .then((res) => {
        setIsDisabled(false);
        if (res.data.status === false) {
          toast.current.show({
            severity: "error",
            summary: t("Error"),
            detail: t(`${res.data.message}`),
            life: 4000,
          });
        }
        if (res.data.status) {
          track.orderSubmitted({
            order_id: res.data.data?.orderId || "",
            order_number: res.data.data?.orderNumber || "",
            service_type: "concierge",
            order_source: localStorage.getItem("room_type") || "room",
            items_count: 1,
            subtotal: 0,
            tax: 0,
            delivery_fee: 0,
            other_fees: 0,
            total_amount: 0,
            is_external_service: false,
          });
          navigate(`/${room_uuid}/HKOrderPlaced`, {
            state: { metadata: { res: res.data.data } },
          });
        }
      })
      .catch((err) => {
        setIsDisabled(false);
        console.log(err);
      });
  };

  return (
    <div className={theme ? "food pb-0" : ""}>
      {theme ? <Title title={text} /> : <HeaderInner headerName={text} />}
      <main className="home-main bg-white back-white book-table pad-top-0">
        <Toast ref={toast} position="bottom-center" />
        {isLoading ? (
          <SpaLoader />
        ) : (
          <>
            {theme ? (
              <BannerServices headerImages={[serviceData?.image]} />
            ) : (
              <div className="con-order-img">
                <img src={serviceData?.image} alt="" />
              </div>
            )}
            <p className="bk-title mt-3">{t(`${serviceData?.title}`)}</p>
            <div className="bk-date">
              <Form.Group
                className="mb-3 row align-items-center justify-content-start"
                controlId="wheelchair-date"
              >
                <p className="col-3 m-0 pl-4">{t("Date")}</p>
                <Form.Control
                  type="date"
                  value={dateInput}
                  onChange={(e) => setDateInput(e.target.value)}
                  className="col-8 ml-2 date-input dt-input"
                />
              </Form.Group>
            </div>
            <div className="bk-time mb-4">
              <Form.Group
                className="mb-3 row align-items-center justify-content-start"
                controlId="wheelchair-time"
              >
                <p className="col-3 m-0 pl-4 no-break">{t("Time")}</p>
                <Form.Control
                  type="time"
                  value={timeInput}
                  onChange={(e) => setTimeInput(e.target.value)}
                  className="col-8 ml-2 time-input dt-input"
                />
              </Form.Group>
            </div>
            <div className="con-email px-2">
              <Form.Group
                className="mb-3 dark-placeholder"
                controlId="wheelchair-email"
              >
                <Form.Control
                  type="email"
                  placeholder={t("Your Email (Optional)")}
                  className="w-100 text-center py-3"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              {errorEmail !== "" && (
                <span className="err_msg">{t(`${errorEmail}`)}</span>
              )}
            </div>
            <div className="con-phone">
              <Form.Group className="mb-3 w-100 px-2">
                <PhoneInputComponent
                  value={phone}
                  onChange={(val) => setPhone(val)}
                />
              </Form.Group>
            </div>
            <div className="con-email px-2">
              <Form.Group
                className="mb-3 dark-placeholder"
                controlId="wheelchair-note"
              >
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder={t("Special Request (Optional)")}
                  className="w-100 text-center py-3"
                  onChange={(e) => setNote(e.target.value)}
                />
              </Form.Group>
            </div>
            <div className="padd-div text-center mt-5">
              <Button
                className="reg-btn book lg"
                onClick={handelBook}
                disabled={isDisabled}
              >
                {t("request")}
              </Button>
            </div>
            <div className="spacer-40 my-5"></div>
          </>
        )}
      </main>
      {theme && <NewFooter />}
    </div>
  );
}

export default Wheelchair;
